import { css } from "styled-components";
import { ThemeProp } from "styles/theme";
import { lighten } from "utils/colors";

export const tablesStyle = css`
  .ant-table-wrapper .ant-table .ant-table-content {
    tr {
      background: ${({ theme }: ThemeProp) => theme.emptyBackground};

      &:hover td {
        background: ${({ theme }: ThemeProp) =>
          lighten(theme.emptyBackground, 20)};
      }
    }
  }
`;
